<template>
    <div class="timeDialogContent">
        <el-dialog 
            title="选择计划" 
            :visible.sync="timeDialogVisible" 
            center 
            show-close 
            custom-class="timeDialog" 
            width="848px"
            :before-close="handleClose">
            <div class="mainContent">
                <div class="exam-list">
                    <div class="exam-item" @click="nextClick(item.examPlanId)" v-for="item in examList" :key="item.examPlanId">
                        {{ item.examPlanName }}
                    </div>
                </div>
                <div class="border"></div>
                <div class="tips">备注：请考生根据自己拟报考的院校进行模拟练习，各学校考试大纲及考试形式详见各学校招生网站。</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Api from '@/api/fetch.js';
export default {
    name: 'ksRouleCodeDialog',
    data() {
        return {
            timeDialogVisible: false,
            examList: []
        }
    },
    methods: {
        handleClose() {
            this.timeDialogVisible = false
        },
        openDialog() {
            Api.getExamList(
                {
                    provinceId: 14,
                    planFlag: 0
                }
            ).then(res => {
                this.examList = res.data;
            });
            this.timeDialogVisible = true
        },
        nextClick(examPlanId){
            this.$emit('nextClick', examPlanId)
            this.handleClose()
        },
        getValidata() {
            Api.getValidata().then((res) => {
                this.ValidataUrl = res.data.imageCode;
                this.formData.uuid = res.data.uuid;
                this.formData.code = res.data.code
                this.formData.validCode = "";
            });
        },
        getTime(id) {
            Api.getTime({"id": id}).then(res => {
                if(res.code == '0') {
                    this.curTimes = res.data.curTimes
                    this.maxTimes = res.data.maxTimes
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.timeDialogContent {
    .timeDialog {
        width: 100%;
        height: 100%;

        .mainContent {
            display: flex;
            justify-content: center;
            align-content: center;
            flex-direction: column;
            position: relative;
            .exam-list{
                display: flex;
                z-index: 2;
                > div{
                    width: 180px;
                    height: 240px;
                    background-color: #fff;
                    box-shadow: inset 0px 0px 10px #ccc;
                    margin: 10px;
                    box-sizing: border-box;
                    padding: 10px 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    font-weight: 600;
                    font-family: 'Courier New', Courier, monospace;
                    border-radius: 10px;
                }
                > div:hover{
                    //box-shadow: inset 0px 0px 10px #f4f4f4;
                    opacity: .77;
                    cursor: pointer;
                }
            }
            .border{
                position: absolute;
                right: 0px;
                top: 0px;
                width: 397.5px;
                height: 260px;
                border-radius: 5px;
                border: 1px solid #ccc;
            }
            .tips{
                color: red;
                // line-height: 24px;
                margin-top: 20px;
                padding-left: 10px;
            }
        }
        .textBox {
            width: 100%;
            margin-bottom: 5px;
            font-weight: 600;
            // height: 100px;
        }
    }
}
</style>